import { render, staticRenderFns } from "./InputScatterplotCustomize.vue?vue&type=template&id=c701f046&"
import script from "./InputScatterplotCustomize.vue?vue&type=script&lang=js&"
export * from "./InputScatterplotCustomize.vue?vue&type=script&lang=js&"
import style0 from "./InputScatterplotCustomize.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAutocomplete,VBtn,VSwitch})
